export default {
  SET_STATE: 'ledgers/SET_STATE',
  FETCH_LEDGER_LIST: 'ledgers/FETCH_LEDGERS_LIST',
  RETRY_LEDGER_SETTLEMENT: 'ledgers/RETRY_LEDGER_SETTLEMENT',
  FETCH_LEDGER_ITEMS_LIST: 'ledgers/FETCH_LEDGER_ITEMS_LIST',
  FETCH_SINGLE_LEDGER: 'ledgers/FETCH_SINGLE_LEDGER',
  FETCH_SINGLE_LEDGER_ITEM: 'ledgers/FETCH_SINGLE_LEDGER_ITEM',
}
